import { classNames } from 'utils/classNames'

type Props = {
  style?: string
  children: JSX.Element
}
export const BaseModal = (props: Props): JSX.Element => {
  const { children, style } = props

  return (
    <div
      className={
        'absolute left-0 top-0 z-10 h-full w-full bg-slate-600 bg-opacity-50'
      }
    >
      <div className={'flex h-full w-full items-center justify-center'}>
        <div className={classNames([style ?? '', 'rounded-lg bg-white p-5'])}>
          {children}
        </div>
      </div>
    </div>
  )
}
